import * as React from "react";

import { IEventViewProps } from "../EventView";

import { LoadingIcon } from "../../Common/LoadingIcon/LoadingIcon";
import { MonthDayCell } from "./MonthDayCell";
import { MonthDayNamesRow } from "./MonthDayNamesRow";
import { MonthDayNamesRowTableHeader } from "./MonthDayNamesRowTableHeader";
import { MonthEventsDataRef } from "./MonthEventsDataRef";

import { IDayCell_Month, IDayCellSlot_Month } from "../../../classes/dayCell_Month";

import * as dates from "../../../reducers/changeTimePeriod";

import * as utils from "./MonthEventViewUtils";

function getWeekRowsForMonth(
  dayCells: IDayCell_Month[],
  allDayText: string,
  currentDate: Date,
  selectedDate: Date,
  todaysDate: Date,
  monthStart: Date,
  monthEnd: Date,
  userDateFormat: string,
  isLoading: boolean,
  loadingText: string,
  portalId: number,
  portletInstanceId: number,
  pageId: number,
  objectId: number,
  contextId: number,
  parentId: number,
  viewMode: string,
  onSetCurrentDate: any,
  onSetEventId: any,
  onSetEventScreenMode: any,
  onSetSelectedDate: any,
  onSetiCalStartDate: any,
  onSetDisplayedEventLocalStartDate: any,
  onSetDisplayedEventLocalEndDate: any,
  onSetViewMode: any,
  onStartAjaxCall: any,
  eventText: string,
  onText: string,
  toText: string,
): JSX.Element[] {

  const daysInMonth = dates.getDaysBetweenDates(monthStart, monthEnd);
  const weeksInMonth = (daysInMonth + 1) / 7;

  const weekRows: JSX.Element[] = [];
  let dayNumber = 0;
  for (let r = 0; r < weeksInMonth; r++) {
    const weekRow: JSX.Element = (
      <tr key={r}>
        {getDayCellsForWeek(
          dayCells,
          dayNumber,
          allDayText,
          currentDate,
          todaysDate,
          selectedDate,
          monthStart,
          userDateFormat,
          isLoading,
          loadingText,
          portalId,
          portletInstanceId,
          pageId,
          objectId,
          contextId,
          parentId,
          viewMode,
          onSetCurrentDate,
          onSetEventId,
          onSetEventScreenMode,
          onSetSelectedDate,
          onSetiCalStartDate,
          onSetDisplayedEventLocalStartDate,
          onSetDisplayedEventLocalEndDate,
          onSetViewMode,
          onStartAjaxCall,
          eventText,
          onText,
          toText,
        )}
      </tr>
    );
    weekRows.push(weekRow);
    dayNumber += 7;
  }

  return weekRows;
}

function getDayCellsForWeek(
  theDayCells: IDayCell_Month[],
  theDayNumber: number,
  allDayText: string,
  currentDate: Date,
  todaysDate: Date,
  selectedDate: Date,
  monthStart: Date,
  userDateFormat: string,
  isLoading: boolean,
  loadingText: string,
  portalId: number,
  portletInstanceId: number,
  pageId: number,
  objectId: number,
  contextId: number,
  parentId: number,
  viewMode: string,
  onSetCurrentDate: any,
  onSetEventId: any,
  onSetEventScreenMode: any,
  onSetSelectedDate: any,
  onSetiCalStartDate: any,
  onSetDisplayedEventLocalStartDate: any,
  onSetDisplayedEventLocalEndDate: any,
  onSetViewMode: any,
  onStartAjaxCall: any,
  eventText: string,
  onText: string,
  toText: string,
) {
  const rowOfDayCells: JSX.Element[] = [];

  for (let c = 0; c < 7; c++) {
    rowOfDayCells.push(
      <MonthDayCell
        key={c}
        allDayText={allDayText}
        currentDate={currentDate}
        selectedDate={selectedDate}
        todaysDate={todaysDate}
        dayCell={theDayCells[theDayNumber]}
        eventText={eventText}
        isLoading={isLoading}
        monthStart={monthStart}
        userDateFormat={userDateFormat}
        onSetCurrentDate={onSetCurrentDate}
        onSetEventId={onSetEventId}
        onSetEventScreenMode={onSetEventScreenMode}
        onSetSelectedDate={onSetSelectedDate}
        onSetiCalStartDate={onSetiCalStartDate}
        onSetDisplayedEventLocalStartDate={onSetDisplayedEventLocalStartDate}
        onSetDisplayedEventLocalEndDate={onSetDisplayedEventLocalEndDate}
        onSetViewMode={onSetViewMode}
        onStartAjaxCall={onStartAjaxCall}
        portalId={portalId}
        portletInstanceId={portletInstanceId}
        pageId={pageId}
        objectId={objectId}
        onText={onText}
        toText={toText}
        contextId={contextId}
        parentId={parentId}
        viewMode={viewMode}
      />);
    theDayNumber++;
  }

  return rowOfDayCells;
}

export const MonthlyEventView = (props: IEventViewProps) => {

  // Convert list of events into array of day cells for days of the month, each with event slots.
  const dayCells: IDayCell_Month[] = utils.transformListOfEventsIntoArrayOfDayCellsForMonth(props);

  // Generate JSX rows and day date cells for the month.
  const isLoading = props.numAjaxCallsInProgress > 0;
  const loadingEventsText = props.text.eventViews.loadingEvents;

  const weekRows = getWeekRowsForMonth(
    dayCells,
    props.text.eventViews.allDay,
    props.currentDate,
    props.selectedDate,
    props.todaysDate,
    props.localFromDate,
    props.localToDate,
    props.userDateFormat,
    isLoading,
    loadingEventsText,
    props.portalId,
    props.portletInstanceId,
    props.pageId,
    props.objectId,
    props.contextId,
    props.parentId,
    props.viewMode,
    props.onSetCurrentDate,
    props.onSetEventId,
    props.onSetEventScreenMode,
    props.onSetSelectedDate,
    props.onSetiCalStartDate,
    props.onSetDisplayedEventLocalStartDate,
    props.onSetDisplayedEventLocalEndDate,
    props.onSetViewMode,
    props.onStartAjaxCall,
    props.text.eventViews.event,
    props.text.eventViews.on,
    props.text.eventViews.to,
  );

  let calViewClass = "CAL-view";
  if (isLoading) { calViewClass += " disabled"; }

  return (
    <div>
      <div>
        <MonthDayNamesRow firstDayOfWeek={props.firstDayOfWeek} text={props.text} />
        <div className="CAL-displayArea">
          <div className={calViewClass}>
            <LoadingIcon displayIcon={isLoading} text={loadingEventsText} />
            <table className="CAL-V-MV-table">
              <MonthDayNamesRowTableHeader firstDayOfWeek={props.firstDayOfWeek} text={props.text} />
              <tbody>
                {weekRows}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      { /* <MonthEventsDataRef events={props.events} dayCells={dayCells} /> */}

    </div>
  );
};
